import { Link } from "react-router-dom";

function FAQ() {
  return (
    <>
      <article className="FAQ-container">
        <section>
          <h1 className="FAQ-title">FAQ</h1>
          <p>Trouver des réponses rapides aux questions les plus communes au sujet de la plomberie et du chauffage.</p>
        </section>
        <section>
          <div>
            <h2>Comment recourir à nos services.</h2>
            <p>
              Pour recourir à nos services il suffit de remplir le formulaire dans la page contact ou de nous appeler. Nous vous assurons
              une réponse rapide.
            </p>
          </div>
          <div>
            <h2>Quels sont vos services ?</h2>
            <p>
              Nous vous installons tous produits issus de la plomberie et nous vous conseillons sur les produits à acheter. Vous pouvez voir
              où nous nous situons sur la page contact.
            </p>
          </div>
          <div>
            <h2>Êtes-vous disponible en cas d'urgence ?</h2>
            <p>Oui, nous sommes disponible 24/7 pour tous types de problème.</p>
          </div>
          <div>
            <h2>Quels sont vos prix ?</h2>
            <p>Nos prix dépendent de votre demande n'hésitez pas à nous contacter pour un devis gratuit.</p>
          </div>
          <Link to={"/contact"} className="button-two">
            Contact
          </Link>
        </section>
      </article>
    </>
  );
}

export default FAQ;
